// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"02481ea8","10":"a436501c","18":"3633b867","128":"5d4f1024","210":"ed7d078a","351":"d2687a4a","395":"d0d399d2","453":"7c8d9c93","464":"1ed5753b","525":"23cb9e7d","767":"eb95b9bc","820":"f9e787e8","868":"cf03ec7b","871":"02d96382","938":"ca213905"}[chunkId] + ".chunk.js";
};